import React from "react";
import { Image } from "semantic-ui-react";
import styled from "styled-components";
import CheckActive from "../../assets/check-active.png";
import CheckYellow from "../../assets/check-yellow.png";
import BaseComponent from "../BaseComponent";
import PillButton from "./PillButton";

const Wrapper = styled.div`
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  flex-direction: row;
  margin-bottom: 6px;
  margin-top: 0px;
  margin-left: 21px;
  margin-right: 21px;
  background-color: white;
`;

const LeftPanel = styled.div`
  display: flex;
  flex-direction: row;
`;

const RightPanel = styled.div``;

const PublisherName = styled.div`
  color: black;
  font-weight: bold;
  display: inline;
`;

class Publisher extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.validDate = this.validDate.bind(this);
  }

  validDate(dateValue) {
    return dateValue != null && new Date(dateValue) > new Date();
  }

  render() {
    return (
      <Wrapper>
        <LeftPanel>
          <PublisherName>
            {this.props.item.firstName + " " + this.props.item.lastName}
          </PublisherName>
        </LeftPanel>
        <RightPanel>
          {this.props.item.confirmed === 1 ? (
            this.validDate(this.props.item.strongSafetyDate) ||
            this.validDate(this.props.item.weakSafetyDate) ? (
              <Image
                src={
                  this.validDate(this.props.item.strongSafetyDate)
                    ? CheckActive
                    : this.validDate(this.props.item.weakSafetyDate)
                    ? CheckYellow
                    : null
                }
                height={32}
                width={32}
              />
            ) : null
          ) : (
            <PillButton
              onClick={this.props.callback}
              style={{
                width: 80,
                backgroundColor: "white",
                borderColor: "#1cbff2",
                borderWidth: 2,
                borderStyle: "solid",
              }}
            >
              {"Cancel"}
            </PillButton>
          )}
        </RightPanel>
      </Wrapper>
    );
  }
}

export default Publisher;
